<template>
  <div class="py-[20px] text-center text-skin-link md:py-5">
    <i-ho-emoji-sad class="mx-auto" />
    <div class="mt-2 text-base">
      {{ $t('noResultsFound') }}
    </div>
  </div>
</template>
